import { AGREEMENT_PROCESS_FLOW_TYPE, FLOW_TYPE } from 'consts';

export function FlowTypeNumber(flowType: string) {
	switch (flowType.toLowerCase()) {
		case FLOW_TYPE.MV:
		case FLOW_TYPE.RR_MV:
			return AGREEMENT_PROCESS_FLOW_TYPE.InvestmentBankingOnboarding;
		case FLOW_TYPE.EB:
		case FLOW_TYPE.RR_EB:
			return AGREEMENT_PROCESS_FLOW_TYPE.PrivateBankingOnboarding;
		case FLOW_TYPE.ER:
		case FLOW_TYPE.RR_ER:
			return AGREEMENT_PROCESS_FLOW_TYPE.AssetCounseling;
		case FLOW_TYPE.AV:
			return AGREEMENT_PROCESS_FLOW_TYPE.DerivativesInvestment;
		case FLOW_TYPE.ES_MV:
			return AGREEMENT_PROCESS_FLOW_TYPE.PortfolioCreation;
		case FLOW_TYPE.RR_SU:
			return AGREEMENT_PROCESS_FLOW_TYPE.RiskQRenewal;
		default:
			console.error('FLOW_TYPE not found!', flowType);
			return null;
	}
}

export function CreateProcessFlowTypeNumber(flowType: string) {
	switch (flowType.toLowerCase()) {
		case FLOW_TYPE.MV:
			return AGREEMENT_PROCESS_FLOW_TYPE.InvestmentBankingOnboarding;
		case FLOW_TYPE.EB:
			return AGREEMENT_PROCESS_FLOW_TYPE.PrivateBankingOnboarding;
		case FLOW_TYPE.ER:
			return AGREEMENT_PROCESS_FLOW_TYPE.AssetCounseling;
		case FLOW_TYPE.AV:
			return AGREEMENT_PROCESS_FLOW_TYPE.DerivativesInvestment;
		case FLOW_TYPE.ES_MV:
			return AGREEMENT_PROCESS_FLOW_TYPE.PortfolioCreation;
		case FLOW_TYPE.RR_EB:
		case FLOW_TYPE.RR_ER:
		case FLOW_TYPE.RR_MV:
		case FLOW_TYPE.RR_SU:
			return AGREEMENT_PROCESS_FLOW_TYPE.RiskQRenewal;
		default:
			console.error('FLOW_TYPE not found!', flowType);
			return null;
	}
}
